module.exports = __webpack_public_path__ + "static/logo-c7edb626c0cbc10eb0de503738d19178.png";